export const getAreaCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};

export const getAreaUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};
